import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FaqComponent from './FaqComponent'
import { getFaqs } from '../../../../store/reducers/faqs'

import './faqComponents.scss'

class FaqComponents extends React.Component {
    componentWillMount() {
        this.props.getFaqs()
    }
    render() {
        const { api, faqs } = this.props
        return <div className="faq">
            {(faqs[api] || []).map((props, i) => <FaqComponent key={i} {...props} />)}
        </div>
    }
}

FaqComponents.propTypes = {
    api: PropTypes.string.isRequired,
    faqs: PropTypes.object.isRequired,
    getFaqs: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
    getFaqs,
}

const mapStateToProps = ({ faqs }) => ({ faqs: faqs.items })

export default connect(mapStateToProps, mapDispatchToProps)(FaqComponents)



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Faq/FaqComponents.js